export default __webpack_public_path__ + "static/media/bc-kebab-icon.9d210913.svg";